import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface AuctionsPropertyGroupingObject {
  id: number;
  slug: string;
  titleEn: string;
  titleAr: string;
  icon: string;
  sort: number;
  relatedIds: number[];
  isActive: boolean;
}

export interface AuctionsPropertyGroupingListInfo {
  totalItems: number;
  currentPage: number;
  pageSize: number;
  isNext: boolean;
  previous: number;
  auctionsPropertyGroupings: Array<AuctionsPropertyGroupingObject>;
  errors: unknown;
}

@Module
export default class AuctionsPropertyGroupingModule
  extends VuexModule
  implements AuctionsPropertyGroupingListInfo
{
  auctionsPropertyGroupings = [] as Array<AuctionsPropertyGroupingObject>;
  listDdlauctionsPropertyGroupings =
    [] as Array<AuctionsPropertyGroupingObject>;
  totalItems = 0;
  currentPage = 1;
  pageSize = 10;
  previous = 0;
  isNext = true;
  errors = {};

  /**
   * Get auctionsPropertyGroupings list
   * @returns Array<AuctionsPropertyGroupingObject>
   */
  get auctionsPropertyGroupingsList(): Array<AuctionsPropertyGroupingObject> {
    return this.auctionsPropertyGroupings;
  }

  /**
   * Get all none ive auctionsPropertyGroupings list
   * @returns Array<AuctionsPropertyGroupingObject>
   */
  get allListauctionsPropertyGroupings(): Array<AuctionsPropertyGroupingObject> {
    return this.listDdlauctionsPropertyGroupings;
  }

  /**
   * Get total items
   * @returns number
   */
  get auctionsPropertyGroupingsListCount(): number {
    return this.totalItems;
  }

  @Mutation
  [Mutations.SET_AUCTIONS_PROPERTY_GROUPINGS](data) {
    this.auctionsPropertyGroupings = data.data;
    this.totalItems = data.totalItems;
    this.currentPage = data.currentPage;
    this.pageSize = data.pageSize;
    this.isNext = data.isNext;
    this.previous = data.previous;
    this.errors = {};
  }

  @Mutation
  [Mutations.SET_BADGE_CURRENT_PAGE](page) {
    this.currentPage = page;
  }

  @Mutation
  [Mutations.SET_ALL_AUCTIONS_PROPERTY_GROUPINGS](data) {
    this.listDdlauctionsPropertyGroupings = data.data;
  }

  @Mutation
  [Mutations.RESET_AUCTIONS_PROPERTY_GROUPINGS_LIST]() {
    this.auctionsPropertyGroupings =
      [] as Array<AuctionsPropertyGroupingObject>;
    this.totalItems = 0;
    this.currentPage = 1;
    this.pageSize = 10;
    this.previous = 0;
    this.isNext = true;
    this.errors = {};
  }

  @Action
  [Actions.RESET_AUCTIONS_PROPERTY_GROUPINGS_STORE]() {
    this.context.commit(Mutations.RESET_AUCTIONS_PROPERTY_GROUPINGS_LIST);
  }

  @Action
  [Actions.CREATE_AUCTION_PROPERTY_GROUPING](data) {
    ApiService.setAuthorizationHeader();
    return ApiService.post('/auctions-property-grouping', data)
      .then(({ data }) => {
        this.context.commit(Mutations.RESET_AUCTIONS_PROPERTY_GROUPINGS_LIST);
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.DELETE_AUCTION_PROPERTY_GROUPING](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.delete('/auctions-property-grouping', id)
      .then(() => {
        this.context.commit(Mutations.RESET_AUCTIONS_PROPERTY_GROUPINGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AUCTION_PROPERTY_GROUPING]({ id, data }) {
    ApiService.setAuthorizationHeader();
    return ApiService.update('/auctions-property-grouping', id, data)
      .then(() => {
        this.context.commit(Mutations.RESET_AUCTIONS_PROPERTY_GROUPINGS_LIST);
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }

  @Action
  [Actions.UPDATE_AUCTION_PROPERTY_GROUPING_CURRENT_PAGE](val) {
    this.context.commit(
      Mutations.SET_AUCTION_PROPERTY_GROUPING_CURRENT_PAGE,
      val
    );
  }

  @Action
  [Actions.GET_AUCTION_PROPERTY_GROUPING](id) {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/auctions-property-grouping', id);
  }

  @Action
  [Actions.GET_AUCTIONS_PROPERTY_GROUPINGS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.query('/auctions-property-grouping', {
      params: { page: this.currentPage },
    })
      .then(({ data }) => {
        this.context.commit(Mutations.SET_AUCTIONS_PROPERTY_GROUPINGS, data);
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.GET_ALL_AUCTIONS_PROPERTY_GROUPINGS]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/auctions-property-grouping/all')
      .then(({ data }) => {
        this.context.commit(
          Mutations.SET_ALL_AUCTIONS_PROPERTY_GROUPINGS,
          data
        );
        return data.data;
      })
      .catch(({ response }) => {
        console.error(response);
        // this.context.commit(Mutations.SET_ERROR, {
        //   [response.statusText]: [response.data.message],
        // });
      });
  }

  @Action
  [Actions.UPLOAD_AUCTION_GROUPING_ICON]({ data, groupingId }) {
    ApiService.setAuthorizationHeader();
    ApiService.setMultipartHeader();
    return ApiService.post(
      `/auctions-property-grouping/uploadIcon/${groupingId}`,
      data
    )
      .then(({ data }) => {
        return data.data;
      })
      .catch(({ response }) => {
        this.context.commit(Mutations.SET_ERROR, {
          [response.statusText]: [response.data.message],
        });
      });
  }
}
